import { useCode } from '@hook'
import { useAppSelector } from '@store/hooks'
import { FormButton, Modal } from '@ui'
import { getError, showToast } from '@util'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CodeCard } from './CodeStep'

type Props = {
  onClose: () => void
}

export const CodeModal = ({ onClose }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { patientId } = useParams()
  const [selectedCode, setSelectedCode] = useState('')

  const { codes } = useAppSelector(state => state.config)
  const { codes: data, addCode } = useCode({ patient_id: patientId || '' })

  useEffect(() => {
    const existing = data?.[0]?.attributes?.name
    if (existing) setSelectedCode(existing)
  }, [data])

  const handleOnChange = (val: string) => {
    setSelectedCode(val)
    console.log(val)
  }

  const handleSubmit = async () => {
    if (!selectedCode) {
      toast.error('Please select a code')
      return
    }

    setIsLoading(true)
    const payload = {
      data: {
        attributes: codes.find(({ name }) => name === selectedCode),
        relationships: {
          patient: {
            data: {
              id: patientId,
              type: 'patient'
            }
          }
        },
        type: 'code'
      }
    }

    try {
      await addCode(payload)
      showToast('Code updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal onClose={onClose} title="Update Code">
      <div className="flex flex-col flex-1 overflow-auto">
        <div className="overflow-auto">
          <div className="flex flex-col divide-y divide-gray-200">
            {codes?.map(item => (
              <CodeCard
                key={item.name}
                {...item}
                checked={selectedCode === item.name}
                handleOnChange={handleOnChange}
                setSelectedCode={setSelectedCode}
              />
            ))}
          </div>
        </div>
        <FormButton isLoading={isLoading} onClick={handleSubmit} onClose={onClose} submit="Update" />
      </div>
    </Modal>
  )
}

export default CodeModal
